
import { collection, documentId, getDocs, getFirestore, query, where } from 'firebase/firestore';
import { ROLES, shopAuthorityConverter, SHOP_AUTHORITY } from '../entities/ShopAuthority';
import firebase from '../firebase/Firebase';


const store = getFirestore(firebase);

export const getShopAuthority = async (id: string, agentId: string) => {
  const ref = collection(store, SHOP_AUTHORITY).withConverter(shopAuthorityConverter);
  const q = query(ref,
    where(`roles.${agentId}`, 'in', [ROLES.admin, ROLES.member]),
    where(documentId(), '==', id)
  )
  const authorities = await getDocs(q).then((snap) => {
    return snap.docs.map((doc) => {
      return doc.data();
    })
  })
  return authorities[0] || null
};